import { Component, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AccountFilterService } from './account-filter.service';
import { AccountSelectorComponent } from '../../accounts/account-selector/account-selector.component';

@Component({
  selector: 'sales-ui-account-filter',
  templateUrl: './account-filter.component.html',
})
export class AccountFilterComponent {
  private accountGroupId: string;
  private accountGroupName: string;

  @ViewChild('accountSelector') accountSelector: AccountSelectorComponent;

  constructor(
    private readonly accountFilterService: AccountFilterService,
    public dialogRef: MatDialogRef<AccountFilterComponent>,
  ) {}

  setAccountGroupId(accountGroupId: string): void {
    this.accountGroupId = accountGroupId;
    this.accountGroupName = this.accountSelector.accountControl.value.companyName;
  }

  save(): void {
    this.accountFilterService.setAccountGroupId(this.accountGroupId);
    this.dialogRef.close();
  }
}
